module.exports = __webpack_public_path__ + "img/icon_disparo_de_comunicacoes.f5c7414c.svg";